import { render, staticRenderFns } from "./Guidance.vue?vue&type=template&id=1c544380&scoped=true&"
import script from "./Guidance.vue?vue&type=script&lang=js&"
export * from "./Guidance.vue?vue&type=script&lang=js&"
import style0 from "./Guidance.vue?vue&type=style&index=0&id=1c544380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c544380",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer})
